import createIcon from '../../createIcon';

/**
 * @component @name Countertops
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTBWN0MxOCA1LjM0IDE2LjY2IDQgMTUgNEMxMy4zNCA0IDEyIDUuMzQgMTIgN0gxNEMxNCA2LjQ1IDE0LjQ1IDYgMTUgNkMxNS41NSA2IDE2IDYuNDUgMTYgN1YxMEg4QzkuMSAxMCAxMCA5LjEgMTAgOFY0SDRWOEM0IDkuMSA0LjkgMTAgNiAxMEgyVjEySDRWMjBIMjBWMTJIMjJWMTBIMThaTTEzIDE4SDExVjEySDEzVjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Countertops = createIcon('Countertops', [
  [
    'path',
    {
      d: 'M18 10V7C18 5.34 16.66 4 15 4C13.34 4 12 5.34 12 7H14C14 6.45 14.45 6 15 6C15.55 6 16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10H18ZM13 18H11V12H13V18Z',
      key: 'yswf1c',
    },
  ],
]);

export default Countertops;
